export const LOADING_METRIC_BY_FACTOR = "LOADING_METRIC_BY_FACTOR";
export const SAVE_LOADING_METRIC_BY_FACTOR = "SAVE_LOADING_METRIC_BY_FACTOR";
export const GET_METRIC_BY_FACTOR = "GET_METRIC_BY_FACTOR";
export const FORM_FAIL = "FORM_FAIL";
export const METRIC_BY_FACTOR_FAIL = "METRIC_BY_FACTOR_FAIL";
export const LOADING_METRIC_BY_FACTOR_BY_ID = "LOADING_METRIC_BY_FACTOR_BY_ID";
export const GET_METRIC_BY_FACTOR_BY_ID = "GET_METRIC_BY_FACTOR_BY_ID";

